
<div class="fullcontainer" >
  <br />
  <br />
<div class='titleContainer'>
  <h2 class='header' style='color:#006598;'>Job Sign off</h2>


  <div>
    <!-- <button class='btn btn-secondary' routerLink='/quoting/new/accounts'><i class="fas fa-plus"></i> New</button>&nbsp;
    <button class='btn btn-secondary' routerLink='/quoting/products'><i class="fas fa-boxes"></i> Manage Products</button> -->
  </div>

</div>

<br />
<br />

<app-tabs (tabClicked)='this.onTabClicked($event)' [inverse]='true'>
  <app-tab  [active]='this.activeTab === "transport"' title='Transport Sign off'>
<app-job-signoff-transport-land></app-job-signoff-transport-land>
  </app-tab>
  <app-tab [active]='this.activeTab === "manager"' title='Manager Sign off'>
<app-job-signoff-manager-land></app-job-signoff-manager-land>
  </app-tab>
</app-tabs>
